import { Table } from 'dexie';
import db, { DataRepository, Database, Key } from '@/db';
import { PutterShaftForSaveDto } from '../../api/models';

export type TABLE_TYPE = Table<PutterShaftForSaveDto>;

export const TABLE = 'putterShaft';
const SCHEMA = 'putterShaftId, sortId';

class PutterShaftDatabase implements DataRepository<PutterShaftForSaveDto> {
  constructor(private db: Database) {
    db.registerModelSchema(TABLE, SCHEMA);
  }

  get(key: Key): Promise<PutterShaftForSaveDto | undefined> {
    return this.db[TABLE].get(key);
  }

  delete(key: Key): Promise<void> {
    return this.db[TABLE].delete(key);
  }

  update(payload: PutterShaftForSaveDto, key: Key): Promise<PutterShaftForSaveDto> {
    return this.db[TABLE].put(payload, key);
  }

  async bulkAdd(payload: PutterShaftForSaveDto[]): Promise<PutterShaftForSaveDto[]> {
    await this.db[TABLE].clear();
    return this.db[TABLE].bulkPut(payload);
  }

  list(): Promise<PutterShaftForSaveDto[]> {
    return this.db[TABLE].orderBy('sortId').toArray();
  }
}

export const PutterShaftDB = new PutterShaftDatabase(db);
